export default __webpack_public_path__ + "static/media/e-ks-logotype-d.5b586273.svg";